<template>
  <div class="share-page">
    <div class="share-img">
      <div class="img"><img src="../../assets/images/share.jpg" alt=""></div>
    </div>
    <div class="share-btn">长按保存图片，分享至朋友圈</div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style>
.share-page {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px;
  background-color: rgba(0, 0, 0, .45);
}

.share-page .share-img {
  flex: 1;
  position: relative;
}
.share-page .share-img .img{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
}

.share-page .share-img img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  margin: 0 auto;
}

.share-page .share-btn {
  color: #fff;
  display: inline-block;
  margin: 20px auto 0;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 8px 20px;
  font-size: 13px;
}
</style>